/**
 * Converts form values to the appropriate string format for API calls
 */
export const convertAnswerValueToString = (value: unknown): string => {
  if (typeof value === "boolean") {
    return value ? "true" : "false";
  }
  if (typeof value === "number") {
    return value.toString();
  }
  if (typeof value === "string") {
    return value;
  }
  return "";
};

/**
 * Converts API string values to appropriate form values based on question type
 */
export const convertStringToFormValue = (
  value: string | undefined,
  questionType: string,
): string | boolean | number | undefined => {
  if (!value) return "";

  switch (questionType) {
    case "Checkbox":
      return value === "true";
    case "Number":
      return parseFloat(value);
    default:
      return value;
  }
};
